(() => {
  const rootUrl = () => {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };
  const checkoutUrl = () => rootUrl() + 'checkout';
  const offerSeenKey = 'oc-button-offer-seen-v3';
  let offerSeenInMemory = false;
  const hasSeenOffer = () => {
    try { return offerSeenInMemory || sessionStorage.getItem(offerSeenKey) === '1'; }
    catch (_) { return offerSeenInMemory; }
  };
  const rememberOffer = () => {
    offerSeenInMemory = true;
    try { sessionStorage.setItem(offerSeenKey, '1'); } catch (_) { /* private browsing */ }
  };

  const openOfferOrCheckout = async () => {
    if (hasSeenOffer()) {
      window.location.assign(checkoutUrl());
      return;
    }
    const dialog = document.getElementById('OCButtonOffer');
    try {
      const response = await fetch(rootUrl() + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const count = (cart.items || []).reduce((total, item) =>
        total + (item.product_type === 'Pinback Buttons' ? Number(item.quantity || 0) : 0), 0);
      if (count > 0 && count < 5 && dialog && typeof dialog.showModal === 'function') {
        const message = dialog.querySelector('[data-oc-offer-message-template]');
        if (message) message.textContent = message.dataset.ocOfferMessageTemplate
          .replace('COUNT', String(count))
          .replace('REMAINING', String(5 - count));
        dialog.showModal();
        rememberOffer();
        return;
      }
    } catch (error) {
      console.warn('Button offer reminder unavailable', error);
    }
    window.location.assign(checkoutUrl());
  };

  let checking = false;
  const interceptCheckout = (event, button) => {
    if (!button || !button.closest('#CartDrawer, #main-cart-footer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    openOfferOrCheckout().finally(() => { checking = false; });
  };

  document.addEventListener('click', (event) => {
    const backTop = event.target.closest('[data-oc-back-top]');
    if (backTop) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const continueButton = event.target.closest('[data-oc-offer-continue]');
    if (continueButton) {
      window.location.assign(checkoutUrl());
      return;
    }

    interceptCheckout(event, event.target.closest('button[name="checkout"]'));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    interceptCheckout(event, event.submitter);
  }, true);
})();
